import { BaseSupplierAdapter } from '../adapters/BaseSupplierAdapter'
import type { AdapterDeps } from '../adapters/BaseSupplierAdapter'

/** Concrete mock adapter — one class, many supplier codes via factory. */
export class MockSupplierAdapter extends BaseSupplierAdapter {
  readonly supplierCode: string

  constructor(supplierCode: string, deps: AdapterDeps) {
    super(deps)
    this.supplierCode = supplierCode
  }
}
